<template>
    <div class="relative">
        <a-select
            :getPopupContainer="(trigger) => trigger.parentNode"
            :disabled="isDisabled"
            :value="modelValue"
            :placeholder="this.placeholder"
            :allowClear="this.allowClear"
            :filter-option="filterOption"
            :show-search="this.searchable"
            :dropdownMatchSelectWidth="this.dropdownMatchSelectWidth"
            class="w-full"
            mode="multiple"
            @change="updateValue"
        >
            <a-select-option v-for="o in options" :key="o.value">
                {{ o.text }}
            </a-select-option>
        </a-select>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: Array,
        placeholder: {
            type: String,
            default: '',
        },
        allowClear: {
            type: Boolean,
            default: false,
        },
        dropdownMatchSelectWidth: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: false,
        },
        options: Array,
        isDisabled: Boolean,
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value);
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
    },
};
</script>
